import _ from "lodash";
import { IHistory } from "../shared/History";

const HISTORY_KEY = "hist"

export default class History {
    private _sync:IHistory[]
    private _offline:boolean = false

    constructor(){
        try {
            this._sync = JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]")
            if (!(this._sync instanceof Array)) this._sync = []
        }catch(e){
            this._sync = []
        }
    }

    get history(){return this._sync}
    get dirty(){return this._offline || this._sync.length>0}

    setOffline() {
        this._offline = true
        return this
    }
    add(id:string,val:string|null){
        _.remove(this._sync, h => h.id==id)
        this._sync.push({id,ts:Date.now(),val})
        this.save()
    }

    flush(){
        this._sync.length = 0
        this.save()
    }

    save(){
        localStorage.setItem(HISTORY_KEY, JSON.stringify(this._sync))
    }

    clear(){
        this._sync.length = 0
        localStorage.removeItem(HISTORY_KEY)
    }
}